import './cookie-message.scss';

class CookieMessage {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-cookiemessage',
            activeAttr: 'data-cookiemessage-active',
            buttonValue: 'button'
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$enableButton = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.buttonValue}"]`);

        // Options
        this.cookieId = this.$root.getAttribute(this.settings.initAttr);
        this.cookieIsEnabled = false;
    }

    initialize () {        
        const OnetrustInitalizedCallbacks = () => {
            this.cookieIsEnabled = window.enabledCookies.includes(this.cookieId);
            this.toggleState(!this.cookieIsEnabled);
            this.setEvents();
        };

        if (window.oneTrustInitialized) {
            OnetrustInitalizedCallbacks();
        } else {
            window.addEventListener('cookieConsentInitialized', OnetrustInitalizedCallbacks);
        }
    }

    toggleState (active) {
        if (active) {
            this.$root.setAttribute(this.settings.activeAttr, true);
            this.cookieIsEnabled = false;
        } else {
            this.$root.setAttribute(this.settings.activeAttr, false);
            this.cookieIsEnabled = true;
        }
    }

    setEvents () {
        if (this.$enableButton) {
            this.$enableButton.addEventListener('click', () => {
                if (typeof OneTrust !== 'undefined') {  
                    OneTrust.ToggleInfoDisplay();
                }
            });
        }

        const handleConsentChange = () => {
            this.toggleState(!window.enabledCookies.includes(this.cookieId));
        };

        window.addEventListener('cookieConsentChanged', handleConsentChange);
    }
}

export { CookieMessage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-cookiemessage]');
        $$roots.forEach($root => {
            const $rootAPI = new CookieMessage($root);
            $rootAPI.initialize();
        });
    }
});
